<script setup lang="ts">
const props = defineProps<{
	image?: string
	title?: string
	text?: string
	link?: string
}>();
</script>

<template>
	<div class="flex flex-col justify-center">
		<img :src="props.image" alt="" class="w-full h-auto rounded-t-2xl mb-4" />
		<h3 class="text-lg font-semibold text-start text-color my-0">{{ props.title }}</h3>
		<p class="text-sm  text-start text-color my-0" v-html="props.text"></p>
	</div>
</template>
